var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPerfectPack5 = function SvgPerfectPack5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "auto",
    height: "auto",
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#perfect-pack5_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#perfect-pack5_svg__b)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.826,
    cy: 195.668,
    rx: 69.139,
    ry: 24.259,
    fill: "#FEAE52"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M228.01 134.398c0 48.159-41.739 87.334-93.399 87.334-51.66 0-93.398-39.175-93.398-87.334 0-48.159 41.739-87.334 93.398-87.334 51.66 0 93.399 39.175 93.399 87.334Z",
    fill: "#FED052",
    stroke: "url(#perfect-pack5_svg__c)",
    strokeWidth: 2.426
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.611,
    cy: 134.398,
    rx: 94.611,
    ry: 88.547,
    fill: "url(#perfect-pack5_svg__d)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.398,
    cy: 77.389,
    rx: 64.287,
    ry: 36.389,
    fill: "url(#perfect-pack5_svg__e)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#perfect-pack5_svg__f)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.453,
    cy: 144.103,
    rx: 32.75,
    ry: 18.195,
    fill: "url(#perfect-pack5_svg__g)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#perfect-pack5_svg__h)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 184.345,
    cy: 144.103,
    rx: 32.75,
    ry: 18.195,
    fill: "url(#perfect-pack5_svg__i)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.98 90.038c12.124-16.44 30.288-7.497 35.89-.556 4.203-7.445 24.185-16.188 36.607-.568 13.087 17.254-14.395 44.579-32.746 58.422a5.117 5.117 0 0 1-6.092.067c-18.778-13.546-46.52-39.926-33.66-57.364Z",
    fill: "url(#perfect-pack5_svg__j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.868 90.038c12.126-16.44 30.29-7.497 35.891-.556 4.204-7.445 24.185-16.188 36.608-.568 13.087 17.254-14.396 44.579-32.747 58.422a5.117 5.117 0 0 1-6.092.067c-18.778-13.546-46.52-39.926-33.66-57.364Z",
    fill: "url(#perfect-pack5_svg__k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.759 163.344c-31.532 9.451-64.128 4.493-79.583-.027-1.598-.467-3.222.706-3.081 2.365 1.26 14.83 10.875 39.069 42.305 39.069 31.384 0 41.708-24.167 43.414-39.003.193-1.674-1.441-2.888-3.055-2.404Z",
    fill: "url(#perfect-pack5_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.722 192.622c-23.289-10.674-50.136-4.447-59.435 0 2.426 3.639 12.614 10.917 29.111 10.917 16.496 0 27.494-7.278 30.324-10.917Z",
    fill: "url(#perfect-pack5_svg__m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.759 163.344c-31.532 9.451-64.128 4.493-79.583-.027-1.598-.467-3.222.706-3.081 2.365 1.26 14.83 10.875 39.069 42.305 39.069 31.384 0 41.708-24.167 43.414-39.003.193-1.674-1.441-2.888-3.055-2.404Z",
    stroke: "url(#perfect-pack5_svg__n)",
    strokeWidth: 2.426
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "perfect-pack5_svg__c",
    x1: 40,
    y1: 141.676,
    x2: 229.223,
    y2: 140.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4D39D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#FDCA4D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4D39D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "perfect-pack5_svg__d",
    x1: 134.611,
    y1: 187.768,
    x2: 134.611,
    y2: 222.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2BD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD58F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "perfect-pack5_svg__j",
    x1: 83.666,
    y1: 90.059,
    x2: 93.118,
    y2: 182.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#990605"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "perfect-pack5_svg__k",
    x1: 185.556,
    y1: 90.059,
    x2: 195.008,
    y2: 182.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#990605"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "perfect-pack5_svg__m",
    x1: 134.611,
    y1: 186.557,
    x2: 134.611,
    y2: 202.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#FF351F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC2118"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "perfect-pack5_svg__n",
    x1: 132.187,
    y1: 119.844,
    x2: 128.548,
    y2: 205.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEB5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "perfect-pack5_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 36.389 -64.2872 0 133.398 77.389)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#FCF2BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF2BD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "perfect-pack5_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.21296 14.55565 -26.20009 2.18332 82.453 144.103)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0B0A",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0B0A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "perfect-pack5_svg__i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.21296 14.55565 -26.20009 2.18332 184.345 144.103)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0B0A",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0B0A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "perfect-pack5_svg__l",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 21.2269 -43.0603 0 134.007 183.524)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#552313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "perfect-pack5_svg__b",
    x: 13.074,
    y: 117.795,
    width: 245.505,
    height: 155.745,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.807,
    result: "effect1_foregroundBlur_747_159"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "perfect-pack5_svg__f",
    x: 34.419,
    y: 110.625,
    width: 96.067,
    height: 66.956,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.642,
    result: "effect1_foregroundBlur_747_159"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "perfect-pack5_svg__h",
    x: 136.312,
    y: 110.625,
    width: 96.067,
    height: 66.956,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.642,
    result: "effect1_foregroundBlur_747_159"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "perfect-pack5_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h270v270H0z"
  })))));
};
export default SvgPerfectPack5;